<template>
  <section :class="[ $style.previewAttributes, 'clearfix' ]">
    <div :class="$style.previewAttributesHeader">
      <h3 :class="$style.previewAttributesHeaderText">
        Preview Attributes
      </h3>
    </div>
    <dl :class="[ $style.previewAttributesList, 'clearfix' ]">
      <div
        v-for="(value, key) in item.attributes"
        :key="key"
        :class="$style.previewAttributesListItem"
      >
        <dt :class="$style.previewAttributesListTerm">
          {{ String(key).replace(/_/g, ' ') }}
        </dt>
        <dd :class="$style.previewAttributesListDef">
          {{ String(value).trim() }}
        </dd>
      </div>
    </dl>
  </section>
</template>
<script>
export default {
  name: 'WorkdayWorkerPreviewAttributes',
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
};
</script>
<style scoped module>
.previewAttributes {
  border-top: 1px solid #b4d77c;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 35px 18px 35px 18px;
}

.previewAttributesHeader {
  float: left;
  width: 20%;
}

.previewAttributesHeaderText {
  font-size: 14px !important;
  font-weight: normal;
  margin: 0;
}

.previewAttributesList {
  float: left;
  width: 80%;
}

.previewAttributesListItem {
  display: inline-block;
  margin-bottom: 20px;
  padding-right: 15px;
  vertical-align: top;
  width: 25%;
}

.previewAttributesListTerm {
  font-size: 11px;
  font-weight: normal !important;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.previewAttributesListDef {
  font-size: 12px;
}
</style>
